import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {CourseComponent} from './course.component';
import {AddCourseFormComponent} from './add-course/add-course.component';

const routes: Routes = [
    {
        path: 'course',
        component: CourseComponent,
        data: {animation: 'course'}
    },
    {
        path: 'course/add',
        component: AddCourseFormComponent,
        data: {animation: 'course/add'}
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class CourseRoutingModule {
}
